import React from "react";
import ScrollOrigin from "../components/ScrollOrigin";
// Components
import Nav from "../components/Nav";
import Footer from "../components/Footer";
// Styles
import styled from 'styled-components';
import AboutPhoto from './../icons/background-photo.jpg';
// Framer Motion
import { motion } from "framer-motion";
import { titleAnim } from '../Animations';
// fade, photoAnim

const About = () => {
    return (
        <div>
        <Nav />
        <AboutPage variants={titleAnim}>
        <p > We are a team of four who all came together at Co.lab, with a mission to identify a problem space, collaborate, and build a product in 8 weeks. </p>
        </AboutPage>
        <Footer/>
        <ScrollOrigin/>
        </div>
    )
}

const AboutPage = styled(motion.div)`
display: flex;
min-height: 62.5vh;
background-image: url(${AboutPhoto});
background-repeat: no-repeat;
background-size: cover;
background-position: center;

  p {
    text-align: center;
    color: black;
    font-size: 2rem;
    line-height: 2.2rem;
    padding: 1rem 12rem;
    margin: 8rem 23rem;
      }
`;

export default About;
